import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useMemo, createContext, useContext, useEffect } from "react";
import { getPlans, resetState, updateState, planActions } from "../../actions/subscriptions";

// SubscriptionsContext to keep the latest state
const SubscriptionsContext = createContext(null);

// useSubscriptionsContext to share this components state everywhere this component is imported
export const useSubscriptionsContext = () => {
  const context = useContext(SubscriptionsContext);

  if (!context) throw new Error("useSubscriptionsContext context must be use inside SubscriptionsProvider");

  return context;
};

const SubscriptionsProvider = ({ children = null, getPlans, resetState, updateState, subscriptions }) => {
  const { plans = [], addOnSeat = { price: 20 } } = subscriptions || {};

  useEffect(() => {
    getPlans();
  }, [getPlans]);

  const memoizedValue = useMemo(
    () => ({ plans, addOnSeat, planActions, resetState, updateState }),
    [plans, addOnSeat, resetState, updateState]
  );

  return <SubscriptionsContext.Provider value={memoizedValue}>{children}</SubscriptionsContext.Provider>;
};

const actionFuncs = { resetState, updateState, getPlans };
const mapStateToProps = ({ subscriptions }) => ({ subscriptions });

SubscriptionsProvider.propTypes = {
  children: PropTypes.node,
  getPlans: PropTypes.func,
  resetState: PropTypes.func,
  updateState: PropTypes.func,
  subscriptions: PropTypes.object,
};

export default connect(mapStateToProps, actionFuncs)(SubscriptionsProvider);
